import React from 'react'
import ReactDOM from 'react-dom'
import momentInit from 'lib/momentInit'
import { Provider } from 'react-redux'
import { addLocaleData, IntlProvider } from 'react-intl'
import en from 'react-intl/locale-data/en'
import pl from 'react-intl/locale-data/pl'
import de from 'react-intl/locale-data/de'
import createSagaMiddleware from 'redux-saga'
import Bus from 'lib/Bus'
import onError from 'lib/saga/onError'
import keepAlive from 'lib/saga/keepAlive'
import createStore from 'reports/tpm/store'
import TPMReport from 'reports/tpm/TPMReport'
import { setToken } from 'reports/tpm/actions'
import rootSaga from 'reports/tpm/saga'

const { timezone, locale, messages } = window

momentInit()
addLocaleData([...en, ...pl, ...de])

const initialState = { config: { locale, timezone } }
const sagaMiddleware = createSagaMiddleware({ onError })
let store = createStore(initialState, [sagaMiddleware])
let saga

Bus.on('page:load', () => {
  const node = document.getElementById('tpm-report')

  if (node) {
    store.dispatch(setToken(node.dataset.token))
    saga = keepAlive(rootSaga, sagaMiddleware)

    ReactDOM.render(
      <IntlProvider locale={locale} messages={messages}>
        <Provider store={store}>
          <TPMReport />
        </Provider>
      </IntlProvider>,
      node
    )
  }
})

Bus.on('page:exit', () => {
  if (saga) {
    saga.cancel()
  }
})
